import { FC, useEffect, useRef, useState } from "react";
import styles from "./PopupNotify.module.scss";
import notify from "../../../images/icons/AdminPanel/notify.svg";
import { useAppSelector } from "../../../services/hooks";
import { formatDate } from "../../../utils/utils";

export const PopupNotify: FC = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  const closePopup = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        closePopup();
      }
    };

    if (openPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openPopup]);
  const { user } = useAppSelector((state) => state.user);
  return (
    <div className={styles.container} ref={popupRef}>
      <img
        src={notify}
        alt="Icon notify"
        onClick={() => setOpenPopup(!openPopup)}
        className={styles.icon}
      />
      <div className={`${styles.popup} ${openPopup && styles.popup_opened}`}>
        {user && (
          <ul className={styles.comments_list}>
            {user.comments && user.comments.length > 0 ? (
              user.comments.map((comment) => (
                <li className={styles.comments_list_item}>
                  <p className={styles.date}>{formatDate(comment.createdAt)}</p>
                  <p className={styles.text}>{comment.comment}</p>
                </li>
              ))
            ) : (
              <p>Keine Kommentare</p>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};
